(function( $ ){
  $.fn.variantColorProduct = function() {
    var colorText;
    this.each(function() {
      if(!$(this).hasClass('s-collection-grid__col')) {
        const colorTitle = $(this).attr('data-color-title');
        const colorTtl = colorTitle && colorTitle.length ? colorTitle : $(this).find('img').attr('alt');
        if ($(this).data('color') == 'c-ref-card' && colorTtl) {
          $(this).closest('.c-ref-card').find('.c-ref-card__ttl').text(colorTtl);
        } else if ($(this).data('color') == 'c-ibutton' && colorTtl) {
          $(this).text(colorTtl);
        } else {
          if (!$(this).find('[class="' + $(this).data('color') + '"]').length && colorTtl) {
            $(this).append('<div class="' + $(this).data('color') + '">' + colorTtl + '</div>')
            colorText = $('.s-main-product__colors__itm.is-active').find('.s-main-product__colors__ttl').text().replaceAll('-', ' ');
            $('[data-product-color]').text(colorText);
          }
        }
      }
    })
  };
})( jQuery );
function getFocusableElements(container) {
  return Array.from(
      container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
        (event.target === container || event.target === first) &&
        event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    const self = this;
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })
    this.incrementValue = 0;
    if (this.input.hasAttribute('data-bulk-qty') && Number(this.input.getAttribute('data-bulk-qty')) >= 1) {
      this.incrementValue = Number(this.input.getAttribute('data-bulk-qty'));
    }

    this.addEventListener('keyup', this.totalPrice.bind(this))
    this.addEventListener('focusout', this.onFocusOut.bind(this))
    this.querySelectorAll('button').forEach(
        (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
    if(document.querySelector('.c-add-ons')) {
      setTimeout(function () {
        self.onInputKey();
      }, 2000)
    }
    this.onInputKey();
  }

  onInputKey() {
    const value = this.input.value;
    const min = Number(this.input.getAttribute('min'));
    const minValue = Number(this.input.getAttribute('min')) ?? 1;


    if (value <= min) {
      this.input.value = min
    }
    if (this.incrementValue >= 1) {
      this.input.value = (Math.ceil(value/this.incrementValue)*this.incrementValue).toString();
    } else if ($(this).hasClass('c-quantity--bulk')) {
      this.input.value = (Math.ceil(value/5)*5).toString();
    }
    if (Number(this.input.value) === minValue)  {
      this.querySelector('[name="minus"]').setAttribute('disabled', 'disabled' )
    } else {
      this.querySelector('[name="minus"]').removeAttribute('disabled' )
    }

  }
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    const minValue = this.input.getAttribute('min') ?? 1;

    if (this.incrementValue >= 1) {
      const value = Number(this.input.value);
      event.target.name === 'plus' ? this.input.value = (value + this.incrementValue).toString() : this.input.value = (value - this.incrementValue).toString();
    } else if ($(this).hasClass('c-quantity--bulk')) {
      const value = Number(this.input.value);
      event.target.name === 'plus' ? this.input.value = (value + 5).toString() : this.input.value = (value - 5).toString();
    } else {
      event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    }
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    if (this.input.value === minValue)  {
      this.querySelector('[name="minus"]').setAttribute('disabled', 'disabled' )
    } else {
      this.querySelector('[name="minus"]').removeAttribute('disabled' )
    }
    // const generalProduct = this.input.closest(".s-main-product__general");
    // if(generalProduct && generalProduct.querySelector('[data-box-n]')) {
    // const boxValue = generalProduct.querySelector('[data-box-n]').getAttribute('data-box-n');
    //   generalProduct.querySelector('[data-box-n]').textContent = Number(boxValue) * Number(this.input.value);
    // }
    // const refProductForm = this.input.closest(".c-ref-product__body");
    // if (refProductForm ) {
    //   const boxValue = refProductForm.querySelector('[data-box-n]').getAttribute('data-box-n');
    //   refProductForm.querySelector('[data-box-n]').textContent = Number(boxValue) * Number(this.input.value);
    // }

    if (this.input.hasAttribute('data-sample-qty')) {
      const sampleMax = Number(this.input.getAttribute('data-sample-max')) || 3;
      if (Number(this.input.value) >= sampleMax) {
        this.querySelector('[name="plus"]').setAttribute('disabled', 'disabled' )
      } else {
        this.querySelector('[name="plus"]').removeAttribute('disabled' )
      }
    }
    this.totalPrice()
  }
  onFocusOut() {
    this.onInputKey();
    if(this.input.value < 0 || this.input.value.length === 0) {
      this.input.value = this.classList.contains('s-free-product__c-quantity') ? '0' : '1';
      if(this.classList.contains('s-free-product__c-quantity')) {
        this.input.dispatchEvent(this.changeEvent);
      }
    }
    if(Number(this.input.value) % 1 !== 0) {
      this.input.value = Math.round(this.input.value).toString();
    }
    this.totalPrice()
  }
  totalPrice() {
    if (
        this.dataset.selectorPrice &&
        this.dataset.parentPrice &&
        this.dataset.price &&
        this.input.value
    ) {

      if (this.dataset.parentPrice && !this.classList.contains('c-add-ons__c-quantity')) {
        if (document.querySelector('[data-product-price]')) {
          document.querySelector('[data-product-price]').textContent = '$' + ((this.input.value * this.dataset.price).toFixed(3)).slice(0, -1);
          if(document.querySelector('[data-product-old-price]') && Number(this.dataset.priceOld) > 0) {
            document.querySelector('[data-product-old-price]').textContent = '$' + ((this.input.value * this.dataset.priceOld).toFixed(3)).slice(0, -1)
          }
        }
      }
      if (
          this.dataset.boxNum &&
          this.dataset.parentBox
      ) {
        if(this.closest(this.dataset.parentBox)) {
          this.closest(this.dataset.parentBox).querySelector('[data-box-n]').textContent = this.dataset.boxNum * this.input.value
          let refPrice = this.closest(this.dataset.parentBox).querySelector('[data-box-price]');
          let currencySymbol = Array.from(refPrice.getAttribute('data-box-price'))[0];
          refPrice.innerHTML = currencySymbol + Number(refPrice.getAttribute('data-box-price').replace(currencySymbol, '').replace(' ','').replace(',','')) * this.input.value;
        }
      }
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);
    this.provinceContainer.style.display = "";
    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else if (!opt || opt == undefined) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
        'click',
        this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    if (poster.getAttribute('data-autoplay') === 'true') {
      this.loadContent();
    }
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    let ths = this;
    if (this.closest('[data-product-ref]')) {
      document.addEventListener('click', (event) => {
        if (event.target.closest('[data-choice-color]') != null ) {
          event.preventDefault();
          let $link = event.target.closest('[data-choice-color]')
          ths.target = 'choose color';
          $(event.target).closest('.c-ref-product__variants').find('.is-active').removeClass('is-active')
          $(event.target).addClass('is-active');
          event.target.closest('[data-product-ref]').setAttribute('data-product-ref', $link.dataset.handle)
          ths.renderProductInfo(ths);
          return false;
        }
      });
    }
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {

    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        option['box'] === 'option';
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
        `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if(this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    window.setTimeout(() => {
      parent.scrollLeft = 0;
      parent.querySelector('li.product__media-item').scrollIntoView({behavior: 'smooth'});
    });
  }

  updateURL() {
    if (!this.currentVariant && !this.closest('[data-product-ref]') || this.dataset.updateUrl === 'false' && typeof  !!this.closest('[data-product-ref]')) return;
    var params = window
        .location
        .search
        .replace('?','')
        .split('&')
        .reduce(
            function(p,e){
              var a = e.split('=');
              p[ decodeURIComponent(a[0])] = decodeURIComponent(a[1]);
              return p;
            },
            {}
        );
    if (this.closest('[data-product-ref]') && this.closest('[data-product-ref]').dataset.productRef) {

      if (typeof  params['variant'] == "undefined") {
        window.history.replaceState({ }, '', `${this.dataset.urlOrigin}?product_ref=${this.closest('[data-product-ref]').dataset.productRef}`);
      } else {
        window.history.replaceState({ }, '', `${this.dataset.urlOrigin}?variant=${params['variant']}&product_ref=${this.closest('[data-product-ref]').dataset.productRef}`);
      }
    } else if (this.currentVariant && this.currentVariant.id) {
      window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}`);

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      let variantId = productForm.closest('[data-product-indicators]').getAttribute('data-product-indicators');
      let products = document.querySelectorAll('[data-product-indicators="'+variantId+'"] [data-box-n]');
      let boxPack = JSON.parse(document.querySelector('#product-'+variantId).getAttribute('data-boxes'));

      let box = boxPack[this.currentVariant.id];

      if  (document.querySelector('[data-product-indicators="'+variantId+'"] [name="calcLength"]')) {
        document.querySelector('[data-product-indicators="'+variantId+'"] [data-calc]').setAttribute('data-box',box);
        document.querySelector('[data-product-indicators="'+variantId+'"] [name="calcLength"]').dispatchEvent(new KeyboardEvent('keyup', { keyCode: 13 }));
      }
      if  (box && this.currentVariant.price && document.querySelector('[data-product-indicators="'+variantId+'"] [data-unit-n]')) {
        let  unitprice = (this.currentVariant.price/100/box).toFixed(3).slice( 0, -1 )
        document.querySelector('[data-product-indicators="' + variantId + '"] [data-unit-n]').textContent = unitprice;
      }

      products.forEach((boxEl) => {
        boxEl.textContent =box;
      });
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo(el) {
    let dataSection = this.dataset.sectionId ? this.dataset.sectionId : this.dataset.section;
    var params = window
        .location
        .search
        .replace('?','')
        .split('&')
        .reduce(
            function(p,e){
              var a = e.split('=');
              p[ decodeURIComponent(a[0])] = decodeURIComponent(a[1]);
              return p;
            },
            {}
        );
    if (this.target == 'choose color' && this.closest('[data-product-ref]') && this.closest('[data-product-ref]').dataset.productRef) {
      if (this.closest('[data-product-indicators]') !== null && this.closest('[data-variant-block]') !== null && this.closest('[data-variant-block]').dataset.variantBlock !== null ) {
        var $this = this.closest('[data-product-indicators]');
        $this.classList.add('is-loading')
        fetch(`/products/${this.dataset.productRef}?section_id=s-product-ref`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, 'text/html');

              let block = html.querySelector('.c-ref-product__body');
              if (block ) {
                const idProduct = html.querySelector('[data-product-indicators]').dataset.productIndicators;
                const colorBlock = $($this).find('[data-colors-group]').html();
                $($this).removeClass('is-loading');
                $($this).attr('data-product-indicators', idProduct)
                $($this).find('.c-ref-product__body').html(block.innerHTML) ;
                $($this).find('[data-colors-group]').html(colorBlock);
                if($($this).find('.c-ref-product__body').hasClass('c-ref-product__body_cart')) {
                  const cartQtyInput = $($this).find('.c-ref-product__body_cart').find('input[name="quantity"]');
                  const cartForm = $($this).find('.c-ref-product__body_cart').find('form');
                  cartQtyInput.attr('form', 'product-form-s-cart-notifications-cart-notification');
                  cartQtyInput.attr('id', 'Quantity-s-cart-notification');
                  cartForm.attr('id', 'product-form-s-cart-notifications-cart-notification');
                  $($this).find('variant-radios').attr('data-section', 's-cart-notifications-cart-notification');

                }
                if ($('.s-cart-notification').length) {
                  $('.s-cart-notification input[type="radio"]').each(function (i){
                    $(this).closest('.c-ibutton').find('label[for="'+ $(this).attr('id')+'"]').attr('for', 's-cart-notification'+i)
                    $(this).attr('id','s-cart-notification'+i )
                  });
                }
                $('[data-color]').variantColorProduct();
              }
            });
      }

      // fetch(`${this.dataset.urlOrigin}?product_ref=${this.dataset.productRef}`)
      //     .then((response) => response.text())
      //     .then((responseText) => {
      //       const html = new DOMParser().parseFromString(responseText, 'text/html');
      //
      //       const block = html.querySelector('[data-variant-block="'+this.closest('[data-variant-block]').dataset.variantBlock+'"]');
      //       let id = html.querySelector('[data-variant-block="'+this.closest('[data-variant-block]').dataset.variantBlock+'"]').closest('[data-product-indicators]').getAttribute('data-product-indicators');
      //       if (block) {
      //         this.closest('[data-product-indicators]').classList.remove('is-loading');
      //         this.closest('[data-product-indicators]').setAttribute('data-product-indicators', id)
      //         this.closest('[data-product-indicators]').innerHTML = block.innerHTML;
      //         $('[data-color]').variantColorProduct();
      //         this.target = null;
      //         $('.c-ref-product__body').removeClass('c-ref-product__body_hidden');
      //         $('[data-toggle="ref-product"]').click(function (e) {
      //           e.preventDefault();
      //           var $tooltip = $(this).find(".c-ref-product__title__info");
      //           if (e.target === $tooltip[0]) return false;
      //           $(this).closest('.c-ref-product').toggleClass('is-open').find('.c-ref-product__body').stop().slideToggle();
      //         });
      //         changeRefQty();
      //       }
      //     });
    } else {
      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${dataSection}`)
          .then((response) => response.text())
          .then((responseText) => {
            const id = `price-${this.dataset.section}`;
            const html = new DOMParser().parseFromString(responseText, 'text/html')
            const destination = document.getElementById(id);
            const source = html.getElementById(id);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
            } else if (destination) {
              let price  = (this.currentVariant.price/100).toFixed(3).slice( 0, -1 );
              destination.innerHTML = '$'+price;
            }
            const price = document.getElementById(`price-${this.dataset.section}`);
            if (price) price.classList.remove('visibility-hidden');
            this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
          });

      if( this.closest('[data-product-ref]') && this.closest('[data-product-ref]').dataset.productRef) {
        if (this.closest('[data-product-indicators]') !== null && this.closest('[data-variant-block]') !== null && this.closest('[data-variant-block]').dataset.variantBlock !== null) {
          var $this = this.closest('[data-product-indicators]');
          var value = Number($($this).find('[data-box-n]').attr('data-box-n')) * Number($($this).find('input[name="quantity"]').val());
          $($this).find('[data-box-n]').text(value);
        }
      }
    }

  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const qtyInput =  productForm.closest('product-form').querySelector('[name="quantity"]');
    const plusButton = productForm.closest('product-form').querySelector('[name="plus"]');
    const minusButton = productForm.closest('product-form').querySelector('[name="minus"]');
    if (!addButton) return;
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      if (plusButton) plusButton.setAttribute('disabled', 'disabled');
      if (minusButton) minusButton.setAttribute('disabled', 'disabled');
      if (qtyInput) qtyInput.setAttribute('disabled', 'disabled');
    } else {
      addButton.removeAttribute('disabled');
      if (plusButton) plusButton.removeAttribute('disabled');
      if (qtyInput) qtyInput.removeAttribute('disabled');
      if (qtyInput && qtyInput.value > 1 && minusButton) {
        minusButton.removeAttribute('disabled');
      }
      if (this.dataset.addCart) {
        addButtonText.textContent = this.dataset.addCart;
      } else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {

    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('[data-variants-radio]'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

var switchW = 991;
var w = $(window).width();
var initSelect = function () {
  $('.c-field__select').each(function (){
    let parent = (typeof $(this).data('parent') != "undefined") ? '' : $(this).parent(),
        pl = $(this).attr('placeholder'),
        search = (typeof $(this).data('search') != "undefined") ? '' : Infinity,
        selectOr = $(this),
        arrow = '<svg xmlns="http://www.w3.org/2000/svg" class="icon icon_chevron-down " viewBox="0 0 24 24" fill="none"><path d="M7 9.5L12 14.5L17 9.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </svg>'
    checkIcon = '<svg class="icon icon_check" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" d="M19.5554 7.1462C20.0822 7.67384 20.0814 8.52862 19.5538 9.05539L11.5906 17.0054C11.0636 17.5315 10.21 17.5315 9.68298 17.0054L5.6462 12.9753C5.11855 12.4485 5.11784 11.5938 5.64461 11.0661C6.17138 10.5385 7.02616 10.5378 7.5538 11.0645L10.6368 14.1424L17.6462 7.14461C18.1738 6.61784 19.0286 6.61855 19.5554 7.1462Z" fill="currentColor"></path></svg>';
    function formatState (state) {
      if (!state.id) {
        return state.text;
      }
      var $state = $('<span>'+state.text + checkIcon+'</span>');
      return $state;
    };
    let select = $(this).select2({
      dropdownParent: parent,
      placeholder: pl,
      minimumResultsForSearch: search,
      templateResult: formatState
    })
        .on('select2:select', function (e) {
          selectOr.attr('data-placeholder', 'false')
        })
        .on('select2:open', function (e) {
          selectOr.removeClass('is-error')
          selectOr.closest('is-error').removeClass('is-error')
        });
    $(this).parent().find('.select2-selection__arrow').html(arrow);
    if ($(this).val() == '' || $(this).val() == '---' ) {
      $(this).attr('data-placeholder', 'true')
    } else {
      $(this).attr('data-placeholder', 'false')
    }
  });
}
$(document).ready(function () {

  $('[data-color]').variantColorProduct();
  $('input[type="tel"]').mask('(000) 000-0000');
  $(document).on('click','.stamped-summary-actions-newreview',function(e) {
    $(this).closest('#stamped-main-widget').toggleClass('is-open')
  });
  $(document).on('click','[data-reload]',function(e) {
    e.preventDefault();
    window.location = window.location.href.split("?")[0];
  });

  mainMenu('.c-main-menu');
  $('[data-toggle="tooltip"]').tooltip();
  $('[data-tab]').uiTabs();
  $('.js-form-validate').formValidate();
  if (!document.querySelector('.s-account')) {
    initSelect();
  }

  $('[data-image-hover]').on('mouseover',  function() {

    if (typeof $(this).data('image-block') != "undefined" && $($(this).data('image-block')).length && typeof $(this).data('image-hover') != "undefined") {
      let image = $($(this).data('image-block'));
      let src = $(this).data('image-hover');
      image.attr('src', src);
    }
  });
  $('[data-image-hover]').on('mouseleave',  function() {
    if (typeof $(this).data('image-block') != "undefined" && $($(this).data('image-block')).length && typeof $(this).data('image-hover') != "undefined") {
      let image = $($(this).data('image-block'));
      let src = image.data('origin-src');
      image.attr('src', src);
    }
  });

  $('[data-toggle-dropdown]').click(function (e) {
    let $dropdown = $($(this).attr('data-toggle-dropdown'));
    if ($dropdown.length) {
      e.preventDefault();
      $(this).toggleClass('is-active');
      $dropdown.stop().slideToggle(function () {
        $dropdown.toggleClass('is-open');
      });
    }
  });

  $('[data-anchore]').click(function (e) {
    let $anchore = typeof $(this).attr("href") != "underfined" ? $($(this).attr('href')) : $($(this).attr('data-anchore'));
    if ($anchore.length) {
      e.preventDefault();
      let $id  = $(this).attr('href');
      let $topId  = $($id).offset().top;
      $('html, body').stop().animate({ scrollTop: $topId }, 400);
    }
  });

  $('[data-show-password]').click(function (e) {
    let type = !$(this).hasClass('is-active')? 'text': 'password';
    let $password = $($(this).data('show-password'));
    $(this).toggleClass('is-active');
    $password.attr('type', type);
  });

  if ($('[data-swiper-scrollbar]').length) {
    var tabChaged = false;
    var currentProgress = 0;
    /*document.querySelector('.c-carousel-scrollbar__swiper-container').addEventListener('transitionend', () => {
      $('.swiper-scrollbar-drag').removeClass('swiper-scrollbar-arrow-r');
      $('.swiper-scrollbar-drag').removeClass('swiper-scrollbar-arrow-l');
      currentProgress = document.querySelector('.c-carousel-scrollbar__swiper-container').getBoundingClientRect().left;
    });*/

    let  swiperScollbar = new Swiper('[data-swiper-scrollbar]', {
      spaceBetween: 0,
      slidesOffsetBefore: 0,
      resistanceRatio: 0.000001,
      momentumBounce: false,
      scrollbar: {
        el: '.swiper-scrollbar',
        snapOnRelease: false,
        draggable: true,
        dragSize: 230
      },
      freeMode: {
        enabled: true
      },
      mousewheel: {
        enabled: true,
        forceToAxis: true,
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1.1,
        },
        768: {
          slidesPerView: 2.2,
        },
        1024: {
          slidesPerView: 3.2,
          spaceBetween: 0,
        }
      },
      on: {
        toEdge: function (sw) {
          /* var activeElement = $(sw.el).closest('.c-tabs__content');
           var activeTab = $('.c-tabs__nav__itm.is-active');
           if(sw.isEnd && activeElement.next().length > 0 && sw.activeIndex > 0) {
             activeElement.removeClass('is-visible');
             activeElement.next().addClass('is-visible');
             activeTab.removeClass('is-active');
             activeTab.next().addClass('is-active');
             $(activeTab)[0].scrollIntoView({'inline': 'center'})
           }
           if(sw.isBeginning && activeElement.prev().length > 0 && tabChaged) {
             activeElement.removeClass('is-visible');
             activeElement.prev().addClass('is-visible');
             activeTab.removeClass('is-active');
             activeTab.prev().addClass('is-active');
           }
           currentProgress = 0;*/
        },
        slideChange: function (sw) {
          tabChaged = true;
        },
        /* progress: function (swiper, progress) {
           var position = swiper.$wrapperEl.offset().left;
           if(position < currentProgress) {
               $('.swiper-scrollbar-drag').removeClass('swiper-scrollbar-arrow-l');
               $('.swiper-scrollbar-drag').addClass('swiper-scrollbar-arrow-r');
             } else {
               $('.swiper-scrollbar-drag').removeClass('swiper-scrollbar-arrow-r');
               $('.swiper-scrollbar-drag').addClass('swiper-scrollbar-arrow-l');
             }
           if(progress === 0 || progress === -0) {
             $('.swiper-scrollbar-drag').removeClass('swiper-scrollbar-arrow-r');
             $('.swiper-scrollbar-drag').removeClass('swiper-scrollbar-arrow-l');
           }
         }*/
      }
    });
  }
  if ($('[data-swiper-reviews]').length) {
    let  swiperReviews = new Swiper('[data-swiper-reviews]', {
      spaceBetween: 0,
      slidesOffsetBefore: 0,
      slidesPerView: 3,
      scrollbar: {
        el: '.swiper-scrollbar',
        snapOnRelease: false,
        draggable: true,
      },
      freeMode: {
        enabled: true
      },
      mousewheel: {
        enabled: true,
        forceToAxis: true,
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1.1,
        },
        768: {
          slidesPerView: 2.1,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 0,
        }
      }
    });
  }
  if ($('[data-swiper-carouse-images]').length) {
    let  swiperReviews = new Swiper('[data-swiper-carouse-images]', {
      spaceBetween: 0,
      slidesOffsetBefore: 0,
      slidesPerView: 2.404,
      freeMode: {
        enabled: true
      },
      mousewheel: {
        enabled: true,
        forceToAxis: true,
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        snapOnRelease: false,
        draggable: true,
      },
      breakpoints: {
        320: {
          slidesPerView: 1.048,
        },
        768: {
          slidesPerView: 1.34,
        },
        1024: {
          slidesPerView: 2.404,
          spaceBetween: 0,
        }
      }
    });
  }
  mainSearch('.s-search');
  $('textarea[data-adaptive-height]').resizeTextarea();
});
$(window).on('load', function(){
  instFeed();
  $(document).on('click','.instafeed-lightbox',function(event) {
    if( $(event.target).closest('.instafeed-post-image').length|| $(event.target).closest('.instafeed-lightbox .description').length  )
      return;
    $(this).find('.close-button a').trigger('click');
  });
})
function instFeed() {
  let clearInstFeedInt = setInterval(hasInstFeed, 20);
  function hasInstFeed() {
    if ($('#insta-feed .slide-page').length) {
      clearInterval(clearInstFeedInt);
      clearInstFeedInt = null;
      addCarousel()
    }
  }
  function addCarousel() {
    let $instBlock = $('#insta-feed');
    let instCurProgress = 0;

    $instBlock
        .addClass('swiper').attr('data-swiper-inst', 'data-swiper-inst')
        .find('>div').addClass('s-instagram__swiper-wrapper swiper-wrapper')
        .find('.slide-page').addClass('s-instagram__swiper-slide swiper-slide')
    $instBlock.find('.slide-page').each(function () {
      let popup = $(this).find('.instafeed-lightbox').clone(true);
      popup.find('.js-lazy-image').attr('src', popup.find('.js-lazy-image').attr('data-src'))
      $(this).find('.instafeed-lightbox').remove();
      $('body').append(popup)

    })
    $instBlock.find('>div').after('<div class="swiper-scrollbar s-instagram__swiper-scrollbar"></div>')
    let  swiperInst = new Swiper('[data-swiper-inst]', {
      spaceBetween: 0,
      slidesOffsetBefore: 0,
      slidesPerView: 3,
      scrollbar: {
        el: '.swiper-scrollbar',
        snapOnRelease: false,
        draggable: true,
      },
      freeMode: {
        enabled: true
      },
      mousewheel: {
        enabled: true,
        forceToAxis: true,
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 2.3,
        },
        768: {
          slidesPerView: 4.1,
        },
        1024: {
          slidesPerView: 6,
          spaceBetween: 0,
        }
      },
    });
  }
}
function  mainSearch(el) {
  let $search = $(el);
  let $btnToggle =  $('[data-search-toggle]');
  let $searchOverlay = $('.s-search__overlay');
  let switchW = 991;
  let w = $(window).width();

  $btnToggle.click(function (e) {
    e.preventDefault();
    $(this).toggleClass('is-active');
    if ($(this).hasClass('is-active')) {
      open();
      $('.s-search__l-container .s-search__input').focus();
    } else {
      close()
    }
  });
  $('[data-search-close]').click(function (e) {
    e.preventDefault();
    close();
  });

  function open() {
    if (w  < switchW && $('.s-header__button_burger').hasClass('is-active')) {
      $('.s-header__button_burger').trigger('click')
    }
    $search.addClass('is-open')
    $('[data-search-empty]').hide();
    $('html').addClass('s-search-is-open');
  }

  function close() {
    $search.removeClass('is-open')
    $('html').removeClass('s-search-is-open');
    $('[data-search-empty]').hide();
    $search.find('form')[0].reset()
    $btnToggle.removeClass('is-active')
  }

  function mainSearchPositon() {
    let headerBtm = $('.s-header').outerHeight() + $('.s-header').offset().top;
    let height =   $(window).height() - headerBtm;
    let bodyH =   $('body').outerHeight(true);
    $search.css({
      top: headerBtm +'px',
      height:  height+'px'
    })
    $searchOverlay.css({
      height:  bodyH - headerBtm+'px',
    })
  }
  mainSearchPositon();
  let clrTimeOut;
  $(window).resize(function () {
    clearTimeout(clrTimeOut);
    clrTimeOut = setTimeout(function () {
      mainSearchPositon()
    }, 200);
  });
  $(window).on('load', function (e) {
    mainSearchPositon();
  });

}
function  mainMenu(el) {
  let flagHover = false;
  let $mainMenu = $(el);
  let $mainSubMenu = $('#l-main-submenu');
  let $megaMenuOverlay = $('#l-main-submenu__overlay');

  let $burger = $('.s-header__button_burger');
  let clrTimeOutHover;
  let clrTimeOutMl;
  if (w < switchW) {
    $mainMenu.find('.c-main-menu__link').each(function () {
      const itemSubmenu = $(this).data('submenu');
      if (!$(itemSubmenu).length) {
        $(this).closest('.c-main-menu__item').find('.s-mega-menu__ttl__icon').hide();
      }
    })
  }
  $mainMenu.find('.c-main-menu__link').on('click', function (e) {
    let $this = $(this);
    let submenu = $(this).data('submenu');
    if (w < switchW && $(submenu).length) {
      e.preventDefault();
      showSubmenu(submenu)
      showSubMenuContainer()
    }
  });
  $mainMenu.find('.c-main-menu__link').on('mouseover', function () {
        let $this = $(this);
        let clrTimeOutHover = $(this);
        let submenu = $(this).data('submenu');
        flagHover = true;
        $('[data-submenu]').removeClass('is-hover')
        clearTimeout(clrTimeOutHover);
        if (w  > switchW && $(submenu).length) {
          if ($mainSubMenu.hasClass('is-open')) {
            showSubmenu(submenu)
          } else {
            clrTimeOutHover = setTimeout(function() {
              if (flagHover) {
                showSubmenu(submenu)
                showSubMenuContainer()
              }
            }, 200);
          }
        } else if (w  > switchW) {
          closeSubMenuContainer()
        }
      }
  );

  $('.l-main-submenu__back__lnk').click(function (e) {
    closeSubMenuContainer();
    e.preventDefault();
  });

  $('.s-mega-menu__ttl__lnk_has-submenu').click(function (e) {
    if ($(window).width() < switchW +1) {
      e.preventDefault();
      let $dropdown = $(this).closest('.s-mega-menu__col').find('>ul');
      $(this).toggleClass('is-active');
      $dropdown.stop().slideToggle('');
    }
  })



  $burger.on('click', function (e) {
    e.preventDefault();
    if (!$(this).hasClass('is-active')) {
      if ($('.s-header__button_search').hasClass('is-active')) {
        $('.s-header__button_search').trigger('click')
      }
      showMainMenu();
    } else {
      closeMainMenu();
      closeSubMenuContainer();

    }

  });
  $mainMenu.find('.c-main-menu__link, .c-main-menu__list').on('mouseleave',  function() {
        flagHover = false;
        let submenu = $(this).data('submenu');
        if (w  > switchW  && !$(submenu).length) {
          closeSubMenuContainer()
        }
      }
  );
  $mainSubMenu.find('#l-main-submenu__overlay').on('mouseover',  function() {
        if (w  > switchW) {
          closeSubMenuContainer()
        }
      }
  );
  $mainSubMenu.find('.l-main-submenu__list').on('mouseleave',  function() {
        if (w  > switchW) {
          closeSubMenuContainer()
        }
      }
  );
  $mainSubMenu.find('.l-main-submenu__list').on('mouseover',  function() {
        if (w  > switchW ) {
          $('[data-submenu]').removeClass('is-hover')
          $('[data-submenu="#'+$('.s-mega-menu.is-open').attr('id')+'"]').addClass('is-hover')
          showSubMenuContainer();
        }
      }
  );


  function showSubMenuContainer(el) {
    $mainSubMenu.addClass('is-open');
    $('html').addClass('main-menu-is-open');
  }

  function showSubmenu(el) {
    $('.s-mega-menu').removeClass('is-open')
    $(el).addClass('is-open')
  }

  function showMainMenu() {
    $burger.addClass('is-active');
    $mainMenu.addClass('is-open');
    $('html').addClass('main-menu-is-open');
  }
  function closeSubMenuContainer() {
    $('[data-submenu]').removeClass('is-hover')
    $mainSubMenu.removeClass('is-open');
    $mainSubMenu.find('.s-mega-menu').scrollTop(0);
    if (w  > switchW) {
      $('html').removeClass('main-menu-is-open');
    }
  }
  function closeMainMenu() {
    $burger.removeClass('is-active');
    $mainMenu.removeClass('is-open');
    $('html').removeClass('main-menu-is-open');
  }

  function mainMenuPositon() {
    let headerBtm = $('.s-header').outerHeight() + $('.s-header').offset().top;
    let height =   $(window).height() - headerBtm;
    let bodyH =   $('body').outerHeight(true);
    let ttlBackH = $mainSubMenu.find('.l-main-submenu__back__lnk').outerHeight()*2;
    $mainSubMenu.css({
      top: headerBtm +'px',
      height:  height+'px'
    })
    $megaMenuOverlay.css({
      height:  bodyH - headerBtm+'px',
    })
    if ($(window).width() > switchW) {
      $mainMenu.removeAttr('style')
      $mainSubMenu.find('.s-mega-menu').removeAttr('style')
    } else {

      $mainSubMenu.find('.s-mega-menu').css({
        height:  height - ttlBackH+'px',
      })
      $mainMenu.css({
        top: headerBtm +'px',
        height:  height+'px',
      })
    }
  }
  mainMenuPositon();
  let clrTimeOut;
  $(window).resize(function () {
    clearTimeout(clrTimeOut);
    clrTimeOut = setTimeout(function () {
      mainMenuPositon()
    }, 200);
  });
  $(window).on('load', function (e) {
    mainMenuPositon();
  });

}

$.fn.uiTabs = function() {
  let obj = this;
  let hash = window.location.hash ? window.location.hash: null;
  let showTab = function (link) {
    let tab = 'page_'+ $(link).attr('href').replace('#', '');
    let $tab = $($(link).attr('href'));
    window.location.hash = tab;
    $(link).closest('.c-tabs__nav__itm').addClass('is-active').siblings().removeClass('is-active');
    $($tab).addClass('is-visible').siblings().removeClass('is-visible');

    // $('html, body').animate({
    //   scrollTop: $(link).offset().top,
    // }, 400)
  }
  obj.each(function (){
    let $link = $(this);
    let tab = '#page_'+ $(this).attr('href').replace('#', '');
    if (hash == tab) {
      showTab($(this));
    }
    $link.click(function(e) {
      e.preventDefault();
      showTab($(this));
    });
  });
};


// Validate Forms
(function($) {
  $.fn.formValidate = function() {
    let classValidate = 'is-validate',
        classError    = 'is-error',
        regexpEmail   = /.+@.+\..+/i;

    this.each(function (index, element) {
      let $form         = $(element).closest('form'),
          $submitButton = $('button[type=submit]', $form).length > 0 ? $('button[type=submit]', $form) : $('button', $form);
      function error(el) {
        let $parent = typeof $(el).data('parent') !="undefined" &&  $(el).data('parent')!== '' ? $($(el).data('parent')): $(el).parent();
        $(el).addClass(classError).removeClass(classValidate);
        $parent.addClass(classError).removeClass(classValidate);
        // $submitButton.attr('disabled', true);
      }
      function validate(el) {
        let $parent = typeof $(el).data('parent') !="undefined" &&  $(el).data('parent')!== '' ? $($(el).data('parent')): $(el).parent();
        $(el).removeClass(classError).addClass(classValidate)
        $parent.removeClass(classError).addClass(classValidate);
        if ($('.is-error:visible',$form).length === 0) {
          $submitButton.removeAttr('disabled');
        }
      }
      function check (element) {
        let elType = $(element).attr('type');
        let elTag  = element.tagName;
        if (
            ($(element).is('[required]') && $(element).val().trim() === '' && (elType === 'text' || elType === 'tel' || elType === 'email' || elTag === 'TEXTAREA')) ||
            (elType === 'checkbox' && $(element).is(':checked') === false)
        ) {

          error($(element));
        } else if (typeof $(element).data('pass2') !== 'undefined') {
          let pass01 = $('[data-pas1]', $form).val().trim(),
              pass02 = $('[data-pas2]', $form).val().trim();
          if (pass01 !== pass02) {
            error($('[data-pas1], [data-pas2]', $form));
          }

        } else if ($(element).attr('type') === 'email' &&
            !regexpEmail.test($(element).val()))
        {
          error($(element));
        } else if ($(element).attr('type') === 'radio' && !$('[name="'+$(element).attr('name')+'"]:checked').length && !$(element).hasClass('no_required'))
        {
          error($(element));
        } else if (typeof $(element).attr('pattern') !== 'undefined' &&
            !new RegExp($(element).attr('pattern')).test($(element).val()) && !$(element).hasClass('no_required'))
        {
          error($(element));
        } else if (typeof $(element).attr("maxlength") !== 'undefined' && $(element).val().length > parseInt($(element).attr("maxlength")) || typeof $(element).attr("maxlength") !== 'undefined' && ($(element).val().match(/\n/g) || []).length > 9 ) {
          error( $(element));
        } else {
          validate($(element));
        }
      }
      $('input[type="radio"]').change(function () {
        $(this).parent().removeClass('is-error');
        $('[name="'+$(this).attr('name')+'"]').removeClass('is-error');
      });
      function checkInput(element) {
        if (element.tagName === 'FORM') {
          let $elements = $('input, textarea, select', $(element));
          $elements.each(function (index, element) {
            check(element);
          })
        } else {
          check(element);
        }
      }
      // $form.keyup(function (event) {
      //   checkInput(event.target);
      // });
      if ($('input[type="checkbox"]', $form).length > 0 || $('select', $form).length > 0) {
        $('input[type="checkbox"], select', $form).on('change', function (event) {
          checkInput(event.target);
        });
      }
      $('input, textarea, select', $(element)).focusout(function (event) {
        if ($(event.target).val() === '') {
          validate(event.target);
        } else {
          checkInput(event.target);
        }
      });
      $submitButton.on('click.submitForm', function (event) {
        checkInput($form.get(0));
        if ($('.is-error:visible',$form).length > 0) {
          event.preventDefault();
        }
      });
    });
  };
})(jQuery);


+function ($) {
  'use strict';
  // TOOLTIP PUBLIC CLASS DEFINITION
  // ===============================

  var Tooltip = function (element, options) {
    this.type       = null
    this.options    = null
    this.enabled    = null
    this.timeout    = null
    this.hoverState = null
    this.$element   = null
    this.inState    = null

    this.init('tooltip', element, options)
  }

  Tooltip.VERSION  = '3.3.7'

  Tooltip.TRANSITION_DURATION = 150

  Tooltip.DEFAULTS = {
    animation: true,
    placement: 'top',
    selector: false,
    template: '<div class="c-tooltip" ><div class="c-tooltip__arrow"></div><div class="c-tooltip__inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: true,
    container: false,
    viewport: {
      selector: 'body',
      padding: 0
    }
  }

  Tooltip.prototype.init = function (type, element, options) {
    this.enabled   = true
    this.type      = type
    this.$element  = $(element)
    this.options   = this.getOptions(options)
    this.$viewport = this.options.viewport && $($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
    this.inState   = { click: false, hover: false, focus: false }

    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
    }

    var triggers = this.options.trigger.split(' ')

    for (var i = triggers.length; i--;) {
      var trigger = triggers[i]

      if (trigger == 'click') {
        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
      } else if (trigger != 'manual') {
        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'

        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
      }
    }

    this.options.selector ?
        (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
        this.fixTitle()
  }

  Tooltip.prototype.getDefaults = function () {
    return Tooltip.DEFAULTS
  }

  Tooltip.prototype.getOptions = function (options) {
    options = $.extend({}, this.getDefaults(), this.$element.data(), options)

    if (options.delay && typeof options.delay == 'number') {
      options.delay = {
        show: options.delay,
        hide: options.delay
      }
    }

    return options
  }

  Tooltip.prototype.getDelegateOptions = function () {
    var options  = {}
    var defaults = this.getDefaults()

    this._options && $.each(this._options, function (key, value) {
      if (defaults[key] != value) options[key] = value
    })

    return options
  }

  Tooltip.prototype.enter = function (obj) {
    var self = obj instanceof this.constructor ?
        obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
    }

    if (self.tip().hasClass('in') || self.hoverState == 'in') {
      self.hoverState = 'in'
      return
    }

    clearTimeout(self.timeout)

    self.hoverState = 'in'

    if (!self.options.delay || !self.options.delay.show) return self.show()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'in') self.show()
    }, self.options.delay.show)
  }

  Tooltip.prototype.isInStateTrue = function () {
    for (var key in this.inState) {
      if (this.inState[key]) return true
    }

    return false
  }

  Tooltip.prototype.leave = function (obj) {
    var self = obj instanceof this.constructor ?
        obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
    }

    if (self.isInStateTrue()) return

    clearTimeout(self.timeout)

    self.hoverState = 'out'

    if (!self.options.delay || !self.options.delay.hide) return self.hide()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'out') self.hide()
    }, self.options.delay.hide)
  }

  Tooltip.prototype.show = function () {
    var e = $.Event('show.bs.' + this.type)

    if (this.hasContent() && this.enabled) {
      this.$element.trigger(e)

      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
      if (e.isDefaultPrevented() || !inDom) return
      var that = this

      var $tip = this.tip()

      var tipId = this.getUID(this.type)

      this.setContent()
      $tip.attr('id', tipId)
      this.$element.attr('aria-describedby', tipId)

      if (this.options.animation) $tip.addClass('fade')

      var placement = typeof this.options.placement == 'function' ?
          this.options.placement.call(this, $tip[0], this.$element[0]) :
          this.options.placement

      var autoToken = /\s?auto?\s?/i
      var autoPlace = autoToken.test(placement)
      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'

      $tip
          .detach()
          .css({ top: 0, left: 0, display: 'block' })
          .addClass(placement)
          .data('bs.' + this.type, this)

      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)
      this.$element.trigger('inserted.bs.' + this.type)

      var pos          = this.getPosition()
      var actualWidth  = $tip[0].offsetWidth
      var actualHeight = $tip[0].offsetHeight

      if (autoPlace) {
        var orgPlacement = placement
        var viewportDim = this.getPosition(this.$viewport)

        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
            placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
                placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
                        placement

        $tip
            .removeClass(orgPlacement)
            .addClass(placement)
      }

      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)

      this.applyPlacement(calculatedOffset, placement)

      var complete = function () {
        var prevHoverState = that.hoverState
        that.$element.trigger('shown.bs.' + that.type)
        that.hoverState = null

        if (prevHoverState == 'out') that.leave(that)
      }

      $.support.transition && this.$tip.hasClass('fade') ?
          $tip
              .one('bsTransitionEnd', complete)
              .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
          complete()
    }
  }

  Tooltip.prototype.applyPlacement = function (offset, placement) {
    var $tip   = this.tip()
    var width  = $tip[0].offsetWidth
    var height = $tip[0].offsetHeight

    // manually read margins because getBoundingClientRect includes difference
    var marginTop = parseInt($tip.css('margin-top'), 10)
    var marginLeft = parseInt($tip.css('margin-left'), 10)

    // we must check for NaN for ie 8/9
    if (isNaN(marginTop))  marginTop  = 0
    if (isNaN(marginLeft)) marginLeft = 0

    offset.top  += marginTop
    offset.left += marginLeft

    // $.fn.offset doesn't round pixel values
    // so we use setOffset directly with our own function B-0
    $.offset.setOffset($tip[0], $.extend({
      using: function (props) {
        $tip.css({
          top: Math.round(props.top),
          left: Math.round(props.left)
        })
      }
    }, offset), 0)

    $tip.addClass('in')

    // check to see if placing tip in new offset caused the tip to resize itself
    var actualWidth  = $tip[0].offsetWidth
    var actualHeight = $tip[0].offsetHeight

    if (placement == 'top' && actualHeight != height) {
      offset.top = offset.top + height - actualHeight
    }

    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)

    if (delta.left) offset.left += delta.left
    else offset.top += delta.top

    var isVertical          = /top|bottom/.test(placement)
    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'

    $tip.offset(offset)
    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
  }

  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
    this.arrow()
        .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
        .css(isVertical ? 'top' : 'left', '')
  }

  Tooltip.prototype.setContent = function () {
    var $tip  = this.tip()
    var title = this.getTitle()

    $tip.find('.c-tooltip__inner')[this.options.html ? 'html' : 'text'](title)
    $tip.removeClass('fade in top bottom left right')
  }

  Tooltip.prototype.hide = function (callback) {
    var that = this
    var $tip = $(this.$tip)
    var e    = $.Event('hide.bs.' + this.type)

    function complete() {
      if (that.hoverState != 'in') $tip.detach()
      if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
        that.$element
            .removeAttr('aria-describedby')
            .trigger('hidden.bs.' + that.type)
      }
      callback && callback()
    }

    this.$element.trigger(e)

    if (e.isDefaultPrevented()) return

    $tip.removeClass('in')

    $.support.transition && $tip.hasClass('fade') ?
        $tip
            .one('bsTransitionEnd', complete)
            .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
        complete()

    this.hoverState = null

    return this
  }

  Tooltip.prototype.fixTitle = function () {
    var $e = this.$element
    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
    }
  }

  Tooltip.prototype.hasContent = function () {
    return this.getTitle()
  }

  Tooltip.prototype.getPosition = function ($element) {
    $element   = $element || this.$element

    var el     = $element[0]
    var isBody = el.tagName == 'BODY'

    var elRect    = el.getBoundingClientRect()
    if (elRect.width == null) {
      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
    }
    var isSvg = window.SVGElement && el instanceof window.SVGElement
    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
    // See https://github.com/twbs/bootstrap/issues/20280
    var elOffset  = isBody ? { top: 0, left: 0 } : (isSvg ? null : $element.offset())
    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null

    return $.extend({}, elRect, scroll, outerDims, elOffset)
  }

  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
        placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
            placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
                /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }

  }

  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
    var delta = { top: 0, left: 0 }
    if (!this.$viewport) return delta

    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
    var viewportDimensions = this.getPosition(this.$viewport)

    if (/right|left/.test(placement)) {
      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
      if (topEdgeOffset < viewportDimensions.top) { // top overflow
        delta.top = viewportDimensions.top - topEdgeOffset
      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
      }
    } else {
      var leftEdgeOffset  = pos.left - viewportPadding
      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
        delta.left = viewportDimensions.left - leftEdgeOffset
      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
      }
    }

    return delta
  }

  Tooltip.prototype.getTitle = function () {
    var title
    var $e = this.$element
    var o  = this.options

    title = $e.attr('data-original-title')
        || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)

    return title
  }

  Tooltip.prototype.getUID = function (prefix) {
    do prefix += ~~(Math.random() * 1000000)
    while (document.getElementById(prefix))
    return prefix
  }

  Tooltip.prototype.tip = function () {
    if (!this.$tip) {
      this.$tip = $(this.options.template)
      if (this.$tip.length != 1) {
        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
      }
    }
    return this.$tip
  }

  Tooltip.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.c-tooltip__arrow'))
  }

  Tooltip.prototype.enable = function () {
    this.enabled = true
  }

  Tooltip.prototype.disable = function () {
    this.enabled = false
  }

  Tooltip.prototype.toggleEnabled = function () {
    this.enabled = !this.enabled
  }

  Tooltip.prototype.toggle = function (e) {
    var self = this
    if (e) {
      self = $(e.currentTarget).data('bs.' + this.type)
      if (!self) {
        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
        $(e.currentTarget).data('bs.' + this.type, self)
      }
    }

    if (e) {
      self.inState.click = !self.inState.click
      if (self.isInStateTrue()) self.enter(self)
      else self.leave(self)
    } else {
      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
    }
  }

  Tooltip.prototype.destroy = function () {
    var that = this
    clearTimeout(this.timeout)
    this.hide(function () {
      that.$element.off('.' + that.type).removeData('bs.' + that.type)
      if (that.$tip) {
        that.$tip.detach()
      }
      that.$tip = null
      that.$arrow = null
      that.$viewport = null
      that.$element = null
    })
  }


  // TOOLTIP PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.tooltip')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tooltip

  $.fn.tooltip             = Plugin
  $.fn.tooltip.Constructor = Tooltip


  // TOOLTIP NO CONFLICT
  // ===================

  $.fn.tooltip.noConflict = function () {
    $.fn.tooltip = old
    return this

  }


  //nav s-faq-content scroll

  $(window).scroll(function(){
    let $faqList = $('.s-faq-content__list');
    $faqList.each(function(i,el){
      let top  = $(el).offset().top-100;
      let bottom = top +$(el).height();
      let scroll = $(window).scrollTop();
      let id = $(el).attr('id');
      if( scroll > top && scroll < bottom){
        $('a.s-faq-content__link-active-1').removeClass('s-faq-content__link-active-1');
        $('a.s-faq-content__link-active').removeClass('s-faq-content__link-active s-faq-content__link-active:hover');
        $('a[href="#'+id+'"]').addClass('s-faq-content__link-active');
      }
    })
  });

}(jQuery);

// textarea resize
(function($) {
  $.fn.resizeTextarea = function() {
    let step = 0;
    function getScrollHeight($input) {
      let savedValue = $input.val();
      $input.val('');
      $input._baseScrollHeight = $input.get(0).scrollHeight;
      $input.val(savedValue);
    }
    this.each(function() {
      if (this.nodeName !== "TEXTAREA") return false;
      let $self           = $(this),
          maxRows         = $self.data('max-rows')|20,
          minRows         = $self.data('min-rows')|0,
          $errorElement   = $self.closest('.c-field').find('.c-field__error'),
          oldErrorMessage = $errorElement.text();

      $self.attr('rows', minRows);
      $self.on('input', function () {
        let rows;
        !$self._baseScrollHeight && getScrollHeight($self);
        if (step === 0) step = $self.get(0).scrollHeight - $self._baseScrollHeight;
        $self.attr('rows', minRows);
        if ($self.get(0).scrollHeight !== $self._baseScrollHeight) {
          rows = Math.ceil(($self.get(0).scrollHeight - $self._baseScrollHeight) / step);
        }
        if (maxRows > rows || typeof rows === 'undefined') {
          $self.attr('rows', minRows + rows);
          // $self.removeAttr('maxlength');
          $errorElement.text(oldErrorMessage);
        } else {
          $errorElement.text('You have reached the message text limit');
          // $self.attr('maxlength', $self.val().length);
          $self.attr('rows', parseInt(maxRows)+parseInt(minRows));
        }
      });
    });
  };
})(jQuery);

(function($) {
  if($('input[name="checkout_url"]').length > 0 && location.href.includes('orderHistory')) {
    $('input[name="checkout_url"]').attr('value', location.origin + '/account#orderHistory' )
  }
})(jQuery);


function changeRefQty() {
  let qtyBtn = document.querySelectorAll('.c-ref-product .c-quantity__button');
  let qtyInput = document.querySelectorAll('.c-ref-product .c-quantity__input');
  let colorVariants = document.querySelectorAll('.c-ref-product__group_variants .c-ibutton__label')
  function changeRef(elem) {
    let refBlock = elem.closest('.c-ref-product');
    let refPrice = refBlock.querySelector('[data-box-price]');
    let currencySymbol = Array.from(refPrice.getAttribute('data-box-price'))[0];
    let refVal = refBlock.querySelector('.ref-unit').getAttribute('data-val');
    let inputQty = refBlock.querySelector('.c-quantity__input').value;
    refBlock.querySelector('span[data-box-n]').innerHTML = refVal * inputQty;
    refPrice.innerHTML = currencySymbol + Number(refPrice.getAttribute('data-box-price').replace(currencySymbol, '').replace(' ','').replace(',','')) * inputQty;
  }
  for (let i = 0; i < qtyBtn.length; i++) {
    qtyBtn[i].addEventListener('click', function(e) {
      changeRef(this)
    });
  }
  for (let i = 0; i < qtyInput.length; i++) {
    qtyInput[i].addEventListener('change', function(e) {
      changeRef(this)
    });
  }
  for (let i = 0; i < colorVariants.length; i++) {
    colorVariants[i].addEventListener('click', function(e) {
      setTimeout(() => {
        changeRef(this)
      }, 10);
    });
  }
}
if (document.querySelector('.c-ref-product')) {
  changeRefQty();
}


// password error
const passwordInput = document.querySelectorAll('input[name="customer[password]"');
for (let i=0; i < passwordInput.length; i++) {
  passwordInput[i].addEventListener('change', function() {
    if (this.value.length < 6) {
      this.closest('.c-field').querySelector('.c-field__error ').innerHTML = 'Password is too short (minimum 6 characters)';
    } else if (this.value.length > 40) {
      this.closest('.c-field').querySelector('.c-field__error ').innerHTML = 'Password is too large (maximum 40 characters)';
    }
  });
}
